import React from 'react';
import { CellProps } from 'react-table';
import { useTranslation } from 'react-i18next';
import { Button, DataTableColumns, VisuallyHidden } from '@tq/ui-components';

import { Organisation } from 'types';
import { useNavigate } from 'hooks';

export const useManageOrganisationColumns = (): DataTableColumns<Organisation>[] => {
  const { t } = useTranslation('manage_consultees');
  const { navigateToOrganisation } = useNavigate();
  return [
    {
      accessor: 'organisationName',
      disableSortBy: false,
      Header: () => t('organisation_name', 'Organisation name'),
      width: 300,
    },
    {
      accessor: 'email',
      disableSortBy: false,
      Header: () => t('email', 'Email'),
      width: 'auto',
    },
    {
      accessor: 'id',
      Cell: (props: CellProps<Organisation, unknown>) => (
        <Button
          variant='secondary'
          size='xs'
          onClick={() => navigateToOrganisation(props.row?.original?.id)}
        >
          {t('manage', 'Manage')}
        </Button>
      ),
      Header: () => <VisuallyHidden>{t('manage_header', 'Manage')}</VisuallyHidden>,
      width: 120,
      disableSortBy: true,
    },
  ];
};
